/**
 * How arche governance values (ADR-026) are named on screen — one map each,
 * so the arche's Access panel and the Company's Owned arches list never call
 * the same audience or role two different things, and no raw enum value
 * (`signed_in`, `publisher`) reaches a user.
 */

import type { ArcheAudienceKind, ArcheCollaboratorRole, ArcheLifecycleState } from '@/lib/api';

export const ARCHE_AUDIENCE: Record<
  ArcheAudienceKind,
  { label: string; short: string; hint: string }
> = {
  anyone: { label: 'Anyone', short: 'Anyone', hint: 'Open without signing in.' },
  signed_in: {
    label: 'Anyone with a Fias account',
    short: 'Fias accounts',
    hint: 'Anyone signed in to Fias can open it.',
  },
  restricted: {
    label: 'Only people I choose',
    short: 'Chosen people',
    hint: 'Its team, plus the people, workspaces, Companies and guilds you add below. Hidden from the store and search.',
  },
};

export const ARCHE_AUDIENCE_ORDER: readonly ArcheAudienceKind[] = [
  'anyone',
  'signed_in',
  'restricted',
];

export const ARCHE_ROLE_LABEL: Record<ArcheCollaboratorRole, string> = {
  owner: 'Owner',
  publisher: 'Publisher',
  viewer: 'Viewer',
};

export const ARCHE_LIFECYCLE_LABEL: Record<ArcheLifecycleState, string> = {
  active: 'Active',
  disabled: 'Disabled',
  deleted: 'Deleted',
};
